import stick1_left from './banner_left/stick1.png';
import flower1_left from './banner_left/flower1.png';
import lens1_left from './banner_left/lens1.png';
import lens1_grayzel_left from './banner_left/lens1_grayzel.png';
import lens1_blue_left from './banner_left/lens1_blue.png';
import stick2_left from './banner_left/stick2.png';
import flower2_left from './banner_left/flower2.png';
import hue1_left from './banner_left/hue1.png';
import hue2_left from './banner_left/hue2.png';
import girl_left from './banner_left/girl.png';
import girl_my_left from './banner_left/girl_my.png';
import flower3_big_left from './banner_left/flower3_big.png';
import lens2_big_left from './banner_left/lens2_big.png';
import lens2_big_grayzel_left from './banner_left/lens2_big_grayzel.png';
import stick4_left from './banner_left/stick4.png';
import flower4_left from './banner_left/flower4.png';
import lens3_left from './banner_left/lens3.png';
import lens3_grayzel_left from './banner_left/lens3_grayzel.png';
import lens3_blue_left from './banner_left/lens3_blue.png';
import stick5_left from './banner_left/stick5.png';
import flower5_left from './banner_left/flower5.png';

import balloon1_right from './banner_right/balloon1.png';
import balloon2_right from './banner_right/balloon2.png';
import balloon3_right from './banner_right/balloon3.png';
import balloon4_right from './banner_right/balloon4.png';
import lens1_right from './banner_right/lens1.png';
import lens2_right from './banner_right/lens2.png';
import only_girl_right from './banner_right/only_girl.png';
import thread_right from './banner_right/thread.png';

import buttonON from './sticker/Sticker_On.png';
import buttonOFF from './sticker/Sticker_Off.png';

import appsflyer_icon from './newUi/appsflyer.png';
import download_icon from './newUi/download.png';

import left_girl_th from './banner_left/left_girl_th.png';
import right_girl from './banner_right/right_girl.png';

import define_flower from './banner_left/define_flower.png';
import butterfly1 from './banner_left/Butterfly_1_small.png';
import butterfly2 from './banner_left/Butterfly_2_small.png';
import butterfly3 from './banner_left/Butterfly_3_small.png';

import define_girl from './banner_right/define_girl.png';

import girl_center_butterfly from './banner_left/left_girl_img.png';
import packshot_vm_ru from './banner_right/right-col-packshot.png';
import button_center from './banner_right/button-center.png';
import logo_center from './banner_right/Logo-Center.png';

import banner_1 from './banner/img_hero-define-1.png';
import banner_2 from './banner/img_hero-define-2.png';
import banner_down_arrow from './banner/sprite_long-arrow.svg';

import vm_left_img from './virtual_mirrror/sprite_blob-blue.svg';

import app_icon from './define/app_icon.png';
import icon_specs_curve from './define/icon_specs-curve.svg';
import icon_specs_material from './define/icon_specs-material.svg';
import icon_specs_o2 from './define/icon_specs-o2.svg';
import icon_specs_package from './define/icon_specs-package.svg';
import icon_specs_power from './define/icon_specs-power.svg';
import icon_specs_thickness from './define/icon_specs-thickness.svg';
import icon_specs_water from './define/icon_specs-water.svg';
import icon_specs_wetting from './define/icon_specs-wetting.svg';
import img_package_all from './define/img_package-all.png';
import img_package_fresh from './define/img_package-fresh.png';
import img_package_classic from './define/img_package-classic.png';
import img_specs_classic from './define/img_specs-classic.png';
import img_wear_classic from './define/img_wear-classic.png';
import img_wear_insert_01 from './define/img_wear-insert-01.svg';
import img_wear_insert_02 from './define/img_wear-insert-02.svg';
import img_wear_insert_03 from './define/img_wear-insert-03.svg';
import img_wear_insert_04 from './define/img_wear-insert-04.svg';
import img_wear_remove_01 from './define/img_wear-remove-01.svg';
import img_wear_remove_02 from './define/img_wear-remove-02.svg';
import img_wear_remove_03 from './define/img_wear-remove-03.svg';
import img_wear_remove_04 from './define/img_wear-remove-04.svg';
import logo_lazada from './define/logo_lazada.svg';
import logo_qoo10 from './define/logo_qoo10.svg';
import sprite_bean_blue from './define/sprite_bean-blue.svg';
import sprite_ring_text_specs from './define/sprite_ring-text-specs.svg';
import sprite_ring_text_classic from './define/sprite_ring_text-classic.svg';
import sprite_ring_text_fresh from './define/sprite_ring-text-fresh.svg';
import on_eye_classic_Accent from './define/on-eye_classic-Accent.jpg';
import on_eye_classic_Bright from './define/on-eye_classic-Bright.jpg';
import on_eye_classic_Charm from './define/on-eye_classic-Charm.jpg';
import on_eye_classic_Chic from './define/on-eye_classic-Chic.jpg';
import on_eye_classic_Natural from './define/on-eye_classic-Natural.jpg';
import on_eye_classic_Sweet from './define/on-eye_classic-Sweet.jpg';
import on_eye_classic_Vivid from './define/on-eye_classic-Vivid.jpg';
import lens_classic_Accent from './define/lens_classic-Accent.png';
import lens_classic_Bright from './define/lens_classic-Bright.png';
import lens_classic_Charm from './define/lens_classic-Charm.png';
import lens_classic_Chic from './define/lens_classic-Chic.png';
import lens_classic_Natural from './define/lens_classic-Natural.png';
import lens_classic_Sweet from './define/lens_classic-Sweet.png';
import lens_classic_Vivid from './define/lens_classic-Vivid.png';
import img_discover_model from './discover/img_discover-model.png';
import img_discover_lens from './discover/img_discover-lens.png';
import sprite_ring_text_range from './discover/sprite_ring-text-range.svg';
import img_discover_splash from './discover/img_discover-splash.png';
import sprite_flower_blue from './discover/sprite_flower-blue.svg';
import sprite_long_arrow from './discover/sprite_long-arrow.svg';

import app_badge_apple from './app-promo/app_badge-apple.svg';
import app_badge_google from './app-promo/app_badge-google.svg';


export {
  vm_left_img,
  left_girl_th,
  right_girl,
  stick1_left,
  flower1_left,
  lens1_left,
  lens1_grayzel_left,
  lens1_blue_left,
  stick2_left,
  flower2_left,
  hue1_left,
  hue2_left,
  girl_left,
  girl_my_left,
  flower3_big_left,
  lens2_big_left,
  lens2_big_grayzel_left,
  stick4_left,
  flower4_left,
  lens3_left,
  lens3_grayzel_left,
  lens3_blue_left,
  stick5_left,
  flower5_left,
  balloon1_right,
  balloon2_right,
  balloon3_right,
  balloon4_right,
  lens1_right,
  lens2_right,
  only_girl_right,
  thread_right,
  buttonON,
  buttonOFF,
  appsflyer_icon,
  download_icon,
  define_flower,
  butterfly1,
  butterfly2,
  butterfly3,
  define_girl,
  girl_center_butterfly,
  packshot_vm_ru,
  button_center,
  logo_center,
  banner_1,
  banner_2,
  banner_down_arrow,
  sprite_bean_blue,
  sprite_ring_text_classic,
  sprite_ring_text_fresh,
  icon_specs_power,
  icon_specs_curve,
  icon_specs_thickness,
  icon_specs_material,
  icon_specs_wetting,
  icon_specs_water,
  icon_specs_o2,
  icon_specs_package,
  img_package_classic,
  img_specs_classic,
  sprite_ring_text_specs,
  img_wear_classic,
  img_wear_insert_01,
  img_wear_insert_02,
  img_wear_insert_03,
  img_wear_insert_04,
  img_wear_remove_01,
  img_wear_remove_02,
  img_wear_remove_03,
  img_wear_remove_04,
  img_package_all,
  logo_lazada,
  logo_qoo10,
  app_icon,
  img_package_fresh,
  on_eye_classic_Accent,
  on_eye_classic_Bright,
  on_eye_classic_Charm,
  on_eye_classic_Chic,
  on_eye_classic_Natural,
  on_eye_classic_Sweet,
  on_eye_classic_Vivid,
  lens_classic_Accent,
  lens_classic_Bright,
  lens_classic_Charm,
  lens_classic_Chic,
  lens_classic_Natural,
  lens_classic_Sweet,
  lens_classic_Vivid,
  // app_icon,
  // img_package_all,
  // logo_lazada,
  // logo_qoo10,
  img_discover_model,
  img_discover_lens,
  // img_package_classic,
  // img_package_fresh,
  sprite_ring_text_range,
  img_discover_splash,
  sprite_flower_blue,
  sprite_long_arrow,
  app_badge_apple,
  app_badge_google,
};
